// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HRqo0","rootNoMargin":"styles_rootNoMargin__10_TB"};